import React, { useState, useEffect } from "react";
import axios from "axios";

const AwardImages = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get("https://backend.skpandco.in/gallery/award");
        const data = response.data;
        const formattedData = data.map((item, index) => {
            let imagePath = "";
            if (item.images) {
                const imgList = item.images.split(",");
                imagePath = imgList[0];
            } else if (item.location) {
                imagePath = item.location;
            }
            return {
                id: index + 1,
                src: imagePath ? `https://backend.skpandco.in${imagePath}` : "",
                alt: `Award Image ${index + 1}`,
                text: item.title,
                content: item.content,
            };
        });
        setImages(formattedData);
      } catch (error) {
        console.error("Error fetching award images:", error);
      }
    };
    fetchImages();
  }, []);

  return (
    <div className="image-container">
      {images.map((img) => (
        <div key={img.id} className="image-wrapper">
          <img
            src={img.src}
            alt={img.alt}
            className="carousel-image"
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/300x300?text=Award+Image";
            }}
          />
          <div className="image-text">
            <h4>{img.text}</h4>
            <p style={{fontSize: '14px', fontWeight: '400', marginTop: '5px'}}>{img.content}</p>
          </div>
        </div>
      ))}
      {images.length === 0 && <p>No award images found.</p>}
    </div>
  );
};

export default AwardImages;
